import { Component, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { LeadService } from 'src/app/private/services/lead.service';
import { TrackingService } from 'src/app/private/services/tracking.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { applyLeadVisibilityToExportPayload } from 'src/app/utils/lead-visibility.util';

@Component({
  selector: 'app-remove-duplicate-leads',
  templateUrl: './remove-duplicate-leads.component.html',
  styleUrls: ['./remove-duplicate-leads.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RemoveDuplicateLeadsComponent {

  isLoading = false;
  btnLoading = false; // For specific button loading, like "Delete All"
  duplicateLeadGroups: any[] = [];
  filteredLeadGroups: any[] = []; // For client-side pagination
  isAdmin: boolean = false; // To check if the user is an admin

  // Pagination properties
  currentPage = 1;
  itemsPerPage = 10;
  pageSizeOptions = [5, 10, 25, 50]; // Options for items per page
  collectionSize = 0; // Total number of duplicate lead groups

   @Output() close = new EventEmitter<void>();

  private destroy$ = new Subject<void>();

  constructor(
    public activeModal: NgbModal, // Used to close the modal
    private toaster: ToastrService,
    private api: LeadService, // Your service to fetch/delete duplicate leads
    private localstorage: LocalStorageService,
    private tracker: TrackingService
  ) {

    this.isAdmin = this.localstorage.checkFullAccessForTableList(
      this.localstorage.getRole()
    );

  }

  ngOnInit(): void {
    this.getDuplicateLeads();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getDuplicateLeads(): void {
    this.isLoading = true;
    this.updateModalLayout();
    //     {
    //     "client_id":4,
    //     "user_id":57,
    //     "showDuplicatesToDelete":true
    // }

    const payload : any = {
      client_id: this.localstorage.getClientId(),
      center_id: this.localstorage.getCenterId(),
      showDuplicatesToDelete: true
    };

    applyLeadVisibilityToExportPayload(
      payload,
      this.localstorage.getUserId(),
      this.isAdmin,
      this.localstorage.getClientId()
    );

    this.api.getDuplicateLeads(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
       this.duplicateLeadGroups = res.duplicatesToDelete; // Directly assign if the data shape matches
        this.collectionSize = this.duplicateLeadGroups.length;
        this.refreshLeadGroups();
        this.isLoading = false;
        this.updateModalLayout();
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Failed to load duplicate leads.');
        this.isLoading = false;
        this.updateModalLayout();
        // Optionally close modal on error if no data can be displayed
        // this.activeModal.dismiss('error');
      }
    });
  }

  refreshLeadGroups(): void {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.filteredLeadGroups = this.duplicateLeadGroups.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
    this.refreshLeadGroups();
  }

  onPageSizeChange(newSize: number): void {
    this.itemsPerPage = newSize;
    this.currentPage = 1; // Reset to first page
    this.refreshLeadGroups();
  }

  confirmDeleteAllDuplicates(): void {
    if (confirm('Are you sure you want to delete ALL duplicate leads? This action will delete all copies of the data and keep only one unique lead for each identified group.')) {
      this.deleteAllDuplicates();
    }
  }

  deleteAllDuplicates(): void {

    this.btnLoading = true;

    const payload: any = {
      client_id: this.localstorage.getClientId(),
      center_id: this.localstorage.getCenterId(),
      showDuplicatesToDelete: false
    };

    applyLeadVisibilityToExportPayload(
      payload,
      this.localstorage.getUserId(),
      this.isAdmin,
      this.localstorage.getClientId()
    );

    this.api.deleteDuplicateLeads(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.toaster.success('All duplicate leads have been successfully deleted!');
        this.tracker.track('Delete', 'All Duplicate Leads', 'All duplicate leads deleted successfully');
        this.btnLoading = false;
         this.getDuplicateLeads(); // Refresh the list after deletion
        setTimeout(()=>{
            this.close.emit(); // Emit close event to parent component
        },1000)
   
      },
      error: (err) => {
        this.toaster.error(err.error.message || 'Failed to delete duplicate leads.');
        this.btnLoading = false;
      }
    });

  }

  closeModal() {
    console.log('Closing modal');
    this.close.emit(); // Emit close event to parent component
  }

  private updateModalLayout(): void {
    setTimeout(() => {
      const modalWindow = document.querySelector('ngb-modal-window.remove-duplicates-modal');
      if (!modalWindow) {
        return;
      }

      const hasTable = !this.isLoading && this.duplicateLeadGroups.length > 0;
      modalWindow.classList.toggle('remove-duplicates-modal--has-table', hasTable);
      modalWindow.classList.toggle('remove-duplicates-modal--compact', !hasTable);
    });
  }
  
}